import React from 'react'

const NaCocktails = (props) => {
    console.log('na/cocktails')
    console.log(props)
   
    let happyHour = props.happyHours
    let mocktails = props.mocktailMenu
    let dessert = props.desserts
    
    const getDesserts = () => {
        return (
            <div className="dessert-left-container">
                desserts go here
            </div>
        )
    }
    const getPrice = (number) => {
        let price = parseFloat(number)
        return price
      }
    const getMocktails = (mocktails) => {
        console.log(mocktails)
        if (mocktails && props.locationId === "pl2"){
            return (
                <div>
                    <div className="cocktail-section-title mocktail-section">Mocktails</div>
                                {mocktails.sections[0].items.map(mocktail => (
                                    <div className="cocktail-item-na">
                                        <div className="cocktail-item-title-na">
                                            {mocktail.name} <span className="cocktail-price"> • {getPrice(mocktail.containers[0].price)}</span>
                                        </div>
                                        <div className="cocktail-item-description-na">
                                            {mocktail.description}
                                        </div>
                                    </div>
                                ))}
                </div>
            )
        } else if (mocktails && props.locationId === "pl5") {
            return (
                <div>
                    <div className="cocktail-section-title mocktail-section">Mocktails</div>
                                {mocktails.sections[0].items.map(mocktail => (
                                    <div className="cocktail-item-na">
                                        <div className="cocktail-item-title-na">
                                            {mocktail.name} <span className="cocktail-price"> • {getPrice(mocktail.containers[0].price)}</span>
                                        </div>
                                        <div className="cocktail-item-description-na">
                                            {mocktail.description}
                                        </div>
                                    </div>
                                ))}
                </div>
            )
        } else {
            return (
                <div>
                    loading...
                </div>
            )
        }
        
    }
    const getHappyHours = (happyHours) => {
        console.log(happyHours)
        if (happyHours && props.locationId === "pl2"){
            return (
                <div className="happy-hour-container pl2">
                    {happyHours.map((promo, key)=> (
                    <div id={`hh-item-${key}`} className="hh-item-na">
                        <div id={`happyhour-title-${key}`} className="happyhour-title-na">
                            {promo.name.label}
                        </div>
                        <div id={`happyhour-description-${key}`} className="happyhour-description-na">
                            {promo.description}
                        </div>
                        <div id={`hh-offers-${key}`} className="hh-offers-na">
                            {promo.offers.map(offer => (
                                <div>
                                    <div>{offer.offer}</div>
                                </div>
                            ))}
                        </div>
                </div>
                ))}
                </div>
            )
        } else if (happyHours) {
            return (
                <div className="happy-hour-container">
                    {happyHours.map((promo, key)=> (
                    <div id={`hh-item-${key}`} className="hh-item-na">
                        <div id={`happyhour-title-${key}`} className="happyhour-title-na">
                            {promo.name.label}
                        </div>
                        <div id={`happyhour-description-${key}`} className="happyhour-description-na">
                            {promo.description}
                        </div>
                        <div id={`hh-offers-${key}`} className="hh-offers-na">
                            {promo.offers.map(offer => (
                                <div>
                                    <div>{offer.offer}</div>
                                </div>
                            ))}
                        </div>
                </div>
                ))}
                </div>
            )
        } else {
            return (
                <div>
                    loading...
                </div>
            )
        }
        
    }
    return (
        <div>
            <div className="happyhour-mocktails-desserts-page-two-column">
                <div className="na-col-left">
                    
                    <div className="na-mocktails">
                        {getMocktails(mocktails)}
                    </div>
                </div>
                <div className="na-col-right">
                    {getHappyHours(happyHour)}
                </div>
            </div>
        </div>
    )
}
export default NaCocktails